/**
 * Internal helpers for GenericDatepicker.
 */
export const Utils = {
  getMonthNames: (format = 'long', locale = 'default') => {
    const formatter = new Intl.DateTimeFormat(locale, { month: format });
    return Array.from({ length: 12 }, (_, i) => formatter.format(new Date(2021, i, 1)));
  },

  getWeekdayNames: (format = 'short', locale = 'default') => {
    const formatter = new Intl.DateTimeFormat(locale, { weekday: format });
    // 2021-05-16 was a Sunday — yields Sun…Sat in locale order starting Sunday
    return Array.from({ length: 7 }, (_, i) => formatter.format(new Date(2021, 4, 16 + i)));
  },
};
